import type { ManifestMap, MetadataMap } from '@xing-com/crate-core-assets';

export function extractMetadataMap(manifest: ManifestMap): MetadataMap {
  return Object.fromEntries(
    Object.entries(manifest).map(([name, { metadata }]) => [name, metadata])
  );
}
